document.addEventListener('alpine:init', () => {
    Alpine.data('climateLoads', () => ({
        mapsLoaded: false,

        lat: 50.104154780460185,
        lng: 14.388127316015627,

        snowMap: null,
        windMap: null,

        snowZonesEC: [
            {id: 0, label: 'I', sk: '0.7'},
            {id: 1, label: 'II', sk: '1.0'},
            {id: 2, label: 'III', sk: '1.5'},
            {id: 3, label: 'IV', sk: '2.0'},
            {id: 4, label: 'V', sk: '2.5'},
            {id: 5, label: 'VI', sk: '3.0'},
            {id: 6, label: 'VII', sk: '4.0'},
            {id: 7, label: 'VIII', sk: '> 4.0'}
        ],

        windZonesEC: [
            {id: 0, label: 'I', vb0: 22.5},
            {id: 1, label: 'II', vb0: 25.0},
            {id: 2, label: 'III', vb0: 27.5},
            {id: 3, label: 'IV', vb0: 33.0},
            {id: 4, label: 'V', vb0: 36.0},
        ],

        handleClick(e) {
            this.lat = +(e.detail.lat);
            this.lng = +(e.detail.lng);

            this.snowMap.setMarker(this.lat, this.lng);
            this.windMap.setMarker(this.lat, this.lng);

            this.snowZone = this.snowMap.getZone(this.lat, this.lng);
            this.windZone = this.windMap.getZone(this.lat, this.lng);

            fetch(`/strecha/get-climate-info?lat=${this.lat}&lng=${this.lng}`)
                .then(response => response.json())
                .then(data => {
                    this.sk.climamaps = data.sk;
                });
        },

        init() {
            window.addEventListener('map-click', (e) => {this.handleClick(e);});

            this.$watch('currentTab', (tab) => {
                if (tab === 'KLIMATICKÁ ZATÍŽENÍ' && !this.mapsLoaded) {
                    setTimeout(() => {
                        this.snowMap = new window.WBApp.utils.Map('snow-map');
                        this.snowMap.addZones(
                            JSON.parse(document.getElementById('snow-zones-json').textContent)
                        );
                        this.snowMap.map.invalidateSize();
                        this.windMap = new window.WBApp.utils.Map('wind-map');
                        this.windMap.addZones(
                            JSON.parse(document.getElementById('wind-zones-json').textContent)
                        );
                        this.windMap.map.invalidateSize();
                        this.mapsLoaded = true;
                    }, 100);
                }
            });

            this.$watch('snowZone', (zone) => {
                this.sk.ec1 = this.snowZonesEC.find(zone => zone.label === this.snowZone).sk;
                if (zone === 'VIII' && this.selectedSkChoice === 'ec1') {
                    this.selectedSkChoice = 'climamaps';
                }
            });

            this.$watch('windZone', () => {
                this.vb0 = this.windZonesEC.find(zone => zone.label === this.windZone).vb0;
            });

            this.sk.ec1 = this.snowZonesEC.find(zone => zone.label === this.snowZone).sk;
            this.vb0 = this.windZonesEC.find(zone => zone.label === this.windZone).vb0;
        },
    }));
});